import Addon from '../../../../shared/classes/addon';
import AgeCode from '../ageCode/ageCode';
import ChannelLogo from '../../atoms/images/channelLogo';
import ChannelTitle from '../../atoms/text/descriptionChannelTitle';
import ChannelUtils from '../../../../shared/utils/channels';
import Corner from '../../../../shared/classes/corner';
import Container from '../../atoms/container/searchDescriptionContainer';
import Content from '../../../../shared/types/enums/content';
import ContentTitle from '../../atoms/text/searchDescriptionContentTitle';
import DateUtils from '../../../../shared/utils/date';
// import Date from '../../atoms/text/descriptionContentDate'; Removed for now
import Event from '../../../../shared/classes/event';
import FocusUtils from '@shared/utils/focus';
import Focus from '@shared/types/enums/focus';
import Header from '../../atoms/container/searchHeaderContainer';
import Info from '../../atoms/container/descriptionMiddleInfoContainer';
import Logos from '../../atoms/container/searchDescriptionChannelLogoContainer';
import OpacityAnimation from '@components/utils/helpers/opacityAnimation';
// import Separator from '../../atoms/text/descriptionDotSeparator'; Removed for now
import Synopsis from '../../atoms/text/searchDetailSynopsis';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import UpgradablePlan from '../plan/upgradablePlan';
import { focusSelector } from '@shared/store/slices/focus.slice';
import { useMemo } from 'react';
import { useAppSelector } from '@shared/store/hooks';
import CatchupAvailability from '../catchup/catchupAvailability';
import SearchImage from '@components/atoms/images/searchImage';
import Tip from '../tip/tip';
import MaskLateral from '../../atoms/mask/descriptionMaskLateral';
import MaskVertical from '../../atoms/mask/descriptionMaskVertical';

export default function SearchDescription({ asset }: { asset?: Event }) {
  const { focus } = useAppSelector(focusSelector);
  const { ageCode, synopsis, title, photo } = asset || {};
  const { channel, date, logo, upgradablePlan } = useMemo(() => {
    const channel = asset?.channel?.title;
    const logo =
      asset?.channel?.logoWhite ||
      (asset as Addon | Corner)?.logoWhite ||
      (asset as Addon | Corner)?.logoColor;
    const upgradablePlan = ChannelUtils.getUpgradablePlan(
      asset?.channel,
      false,
      asset?.type
    );
    const isPastDate = DateUtils.isPastDate(asset?.date?.end);
    const date =
      asset?.date && asset.type === Content.EPG_EVENT && !isPastDate
        ? `${TranslationManager.get(
            'PAGES.DETAIL.DATE.BEGIN'
          )} ${DateUtils.getTime({
            customDate: asset?.date.start,
            displaySeconds: false,
          })} | ${TranslationManager.get(
            'PAGES.DETAIL.DATE.END'
          )} ${DateUtils.getTime({
            customDate: asset?.date.end,
            displaySeconds: false,
          })}`
        : asset?.date && isPastDate && asset?.type !== Content.FAST_EVENT
        ? DateUtils.getTime({
            customDate: asset?.date.start,
            displaySeconds: false,
            displayDay: true,
            displayYear: true,
            displayMonth: true,
          })
        : '';

    return { channel, date, logo, upgradablePlan };
  }, [asset]);

  const { delay, display } = useMemo(() => {
    const display =
      FocusUtils.evaluateFocus(Focus.RAILS_LIST) ||
      focus === Focus.MODAL_INPUT ||
      focus === Focus.FLOATING_MENU;
    const delay = display ? undefined : 0;
    return { delay, display };
  }, [focus]);

  return (
    <OpacityAnimation delay={delay} display={display}>
      <Container>
        <SearchImage src={photo || ''}></SearchImage>
        <MaskLateral left={827} height={342}></MaskLateral>
        <MaskVertical top={290} left={838}></MaskVertical>
        <Header>
          {logo ? (
            <Logos id={'searchDescriptionLogo'}>
              <ChannelLogo
                disableMargin={true}
                disableWidth={true}
                src={logo}
              />
            </Logos>
          ) : null}
          <ContentTitle>{title}</ContentTitle>
        </Header>
        <Info>
          <ChannelTitle>{channel}</ChannelTitle>
          {upgradablePlan ? (
            <UpgradablePlan
              fontBold={false}
              plan={upgradablePlan}
              separator={true}
            />
          ) : asset?.catchup ? (
            <CatchupAvailability date={asset?.date?.start} />
          ) : null}
          {ageCode ? (
            <AgeCode ageCode={ageCode} margin={!!(channel || date)} />
          ) : null}
        </Info>
        <Synopsis>{synopsis}</Synopsis>
        <Tip />
      </Container>
    </OpacityAnimation>
  );
}
